import { userConstants } from '../constants'

const initialState = {
  loading: false,
  profile: null,
  error: null,
  init: false
}

export default function user(state = initialState, action: any) {
  switch (action.type) {
    case userConstants.USER_LOAD:
      return {
        ...state,
        loading: true,
        init: true
      }
    case userConstants.USER_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: action.payload
      }
    case userConstants.USER_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case userConstants.USER_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
